import React from 'react';
import type { DynamicContentSlotEntryType, ConditionalContainerEntryType, RichTextEntryType } from 'tsconfig/types';
import { CmsRichText } from '../contentful/CmsRichText/CmsRichText';
import CmsDynamicContentSlot from '../contentful/CmsDynamicContentSlot/CmsDynamicContentSlot';
import { CmsConditionalContainer } from '../contentful/CmsConditionalContainer/CmsConditionalContainer';

const PAGE_SLUG_TO_GROUPING: Record<string, string> = {
  home: 'home',
  cart: 'cart',
  myaccount: 'myaccount',
  membership: 'myaccount',
  'Search PLP': 'plp',
  category: 'plp',
  pdp: 'pdp',
  'wine-preferences': 'myaccount',
};

export const hideStripBannerForPage = (
  pageSlug: string | undefined,
  stripBannerDisabledPages: string[] | undefined,
): boolean => {
  if (!pageSlug || !stripBannerDisabledPages) {
    return false; // Don't hide if pageSlug is undefined or no disabled pages specified
  }

  const pageGrouping = PAGE_SLUG_TO_GROUPING[pageSlug] || pageSlug;

  return stripBannerDisabledPages.includes(pageGrouping || '');
};

export const isRichTextType = (entry: unknown): entry is RichTextEntryType =>
  (entry as RichTextEntryType)?.sys?.contentType?.sys?.id === 'richtext';

export const isDynamicContentSlotType = (entry: unknown): entry is DynamicContentSlotEntryType =>
  (entry as DynamicContentSlotEntryType)?.sys?.contentType?.sys?.id === 'dynamicContentSlot';

export const renderDynamicContentSlot = (stripBanner: DynamicContentSlotEntryType): JSX.Element | null => {
  const layout = stripBanner.fields?.layout;

  if (!layout || layout.length === 0) {
    return null;
  }

  return (
    <CmsDynamicContentSlot contentItem={stripBanner}>
      {layout.filter(Boolean).map((item, index: number) => {
        const conditionalItem = item as ConditionalContainerEntryType;
        const richTextContent = conditionalItem.fields?.content?.[0] as RichTextEntryType;

        return (
          <CmsConditionalContainer key={conditionalItem.sys?.id || index} contentItem={conditionalItem}>
            {richTextContent?.sys?.contentType?.sys?.id === 'richtext' && <CmsRichText contentItem={richTextContent} />}
          </CmsConditionalContainer>
        );
      })}
    </CmsDynamicContentSlot>
  );
};
